// extracted by mini-css-extract-plugin
export default {"playerwrapper":"movie_playerwrapper__7JAj7","reactplayer":"movie_reactplayer__ifEs+"};